import { SET_SESSION_INTERVAL_ID } from "constants-lib/actionTypes"

export const setSessionIntervalId = (data) => ({
  type: SET_SESSION_INTERVAL_ID,
  payload: data,
})
